import React, { Component } from 'react';
import { getClientDocuments } from '../../Actions/Documents';
import { connect } from 'react-redux';
import { List, OrderedMap } from 'immutable';
import moment from 'moment';
import './Styles/SingleClientDocuments.css'
import { ResourceLink } from '@zorgconnect/shared-portal/Components/ResourceLink.js';

const mapDispatchToProps = (dispatch) => ({
    getClientDocuments: (clientid) => dispatch(getClientDocuments(clientid))
})

const apiUrl = window.location.href.match('zorgconnect.localdev:30') ? "http://clientportal.zorgconnect.localdev:8081" : "";

class SingleClientDocuments extends Component {


    constructor(props) {
        super(props);
        this.state = {
            loaded: false
        }
    }

    componentDidMount() {
        if(this.props.client) {
            getClientDocuments &&this.loadClientDocuments();
        }
    }

    loadClientDocuments() {
        let { client, getClientDocuments } = this.props;
        getClientDocuments && getClientDocuments(client.get('id')).then((documents) => {
            console.log("these are the documents", documents);
            this.setState({
                documents: documents || OrderedMap(),
                loaded: true
            })
        })
    }

    componentDidUpdate(prevProps, prevState) {

        let { getClientDocuments } = this.props;

        if(prevProps.client != this.props.client) {
            this.loadClientDocuments();
        }

        if(prevState.loaded && !this.state.loaded) {
            this.loadClientDocuments();
        }

    }

    render() {
        let { clientportal } = this.props;
        let { documents } = this.state;
        console.log("documents", documents);

        documents = (documents || List()).sort((a,b) => {
            if(a.get('typeid') != b.get('typeid')) {
                return a.get('typeid') - b.get('typeid');
            }
            return Number(b.get('created')) - Number(a.get('created'));
        });

        let grouped = documents.groupBy(x => x.get('typeid'));

        let canseedocuments = clientportal.get('canseedocuments');

        if(!canseedocuments) {
            return <div />
        }

        return <div className="card ">
        
            <div className="card-body">
            
                <div className="documents document-table">

                    {grouped.map((documents, index) => {


                        return <div className="document-table-group" key={(index || 0).toString()}>

                           
                            <div className="document-table-group-header">
                                {documents.first().getIn(['type', 'metadescriptors', 'folder'])}
                            </div>
                            <div className="document-table-group-body">
                                 {(documents || List()).map((document) => {

                                    return <Document document={document} portalType="clientportal" documentType="clients"  key={document.get('id').toString()} />


                                   

                                }).toList()}
                            </div>

                           

                        </div>

                    }).toList()}

                    {/* <div className="documents-header document-table-row">
                        
                        <div className="document-table-item">Document</div>
                        <div className="document-table-item">Toelichting</div>
                        <div className="document-table-item">Geldig t/m</div>
                        <div className="document-table-item">Bestanden</div>
                        

                    </div> */}


                    

                    

                </div>

            </div>

        </div>
    }


}

function Document({ document, portalType, documentType }) {

    let files = document.get('files', List()) || List();
    let firstFile = files.first();
    let firstFileName = firstFile && files.keySeq().first();
    return <div className="document-table-row">

        <div className="document-table-item">
            <div className="document-table-item-content">
                { files.size == 1 && <ResourceLink className="" href={`${apiUrl}/${portalType}/files/${documentType}/${document.get('entityid')}/${document.get('id')}/${firstFileName}`}>
                    {document.get('name')}
                </ResourceLink> || document.get('name') }
                
                { files.size > 1 && <ul>
                    {(document.get('files') || []).map((file, filename) => {
                        return (
                            <li key={filename}>
                                <ResourceLink className="" href={`${apiUrl}/${portalType}/files/${documentType}/${document.get('entityid')}/${document.get('id')}/${filename}`}>{filename}</ResourceLink>
                            </li>
                        )
                    }).toList()}

                    </ul>
                }
            </div>
        </div>
     </div>

}


export default connect(null, mapDispatchToProps)(SingleClientDocuments);